import { ApiUrls } from './api-urls';
import { LoaderService } from './loader.component';
import { HostListener, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, Subject, throwError } from 'rxjs';
import {
  finalize,
  map,
  catchError,
  takeUntil,
  tap,
  filter,
} from 'rxjs/operators';
import {
  ActivatedRoute,
  ActivationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LocationStrategy } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
// import jwt_decode from 'jwt-decode';
// import jwt_encode from 'jwt-encode';

@Injectable()
export class ApiCallInterceptor implements HttpInterceptor {
  private pendingHTTPRequests$ = new Subject<void>();
  apiCount = 0;
  nonLoadingApis = [
    ApiUrls.networkStatus,
    ApiUrls.xlBulkInvoice,
    ApiUrls.sendEmail,
    ApiUrls.invoices,
    ApiUrls.taxPayerDefault,
    ApiUrls.taxpayerlocation,
    // ApiUrls.summary_activity_log
    ApiUrls.emailQueue,
    ApiUrls.posChecks,
    ApiUrls.summary_amendment,
    ApiUrls.reconcilation,
    // ApiUrls.users,
    ApiUrls.check_old_password,
    ApiUrls.syncdashboard_invoice_count,
    // ApiUrls.syncLogsDashboard,
    ApiUrls.missing_irn_generation,
    ApiUrls.getExactTotalInvoiceData,
    ApiUrls.posChecksHistory,
    ApiUrls.uploadFile,
    ApiUrls.get_todo_invoices,
    ApiUrls.mei_todo_invoice_count,
    ApiUrls.get_taxpayer_details,
    ApiUrls.todo_dashboard,
  ];

  private cache = new Map<string, any>();
  constructor(
    private loader: LoaderService,
    private router: Router,
    private toastr: ToastrService,
    private cookie: CookieService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event: any) => {
        if (event.restoredState) {
          this.cancelPendingRequests();
        }
      });
    // location.onPopState((res) => {
    //   this.router.events.subscribe(event => {
    //     if (event instanceof ActivationEnd) {
    //       this.cancelPendingRequests();
    //     }
    //   })

    // });
  }

  public cancelPendingRequests() {
    this.pendingHTTPRequests$.next();
  }

  public onCancelPendingRequests() {
    return this.pendingHTTPRequests$.asObservable();
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.apiCount++;
    const body = request.body;
    let withCredentials = true;
    if (body instanceof FormData) {
      if (body.get('cmd') == 'login') {
        withCredentials = false;
      }
    }

    if (this.nonLoadingApis.indexOf(request.url) == -1) {
      this.loader.showLoader();
    }
    if (request.url.includes('method/frappe.client.get_value')) {
      this.loader.hideLoader();
    }

    if (
      request.url.includes(
        'method/version2_app.version2_app.doctype.company.company.bench_migrate'
      )
    ) {
      this.loader.hideLoader();
    }
    if (
      request.url.includes(
        'method/version2_app.version2_app.doctype.company.company.updateUiProd'
      )
    ) {
      this.loader.hideLoader();
    }
    if (
      request.url.includes(
        'method/version2_app.clbs.doctype.summaries.summaries.summary_activity_log?'
      )
    ) {
      this.loader.hideLoader();
    }
    if (
      request.url.includes(
        'method/version2_app.version2_app.doctype.xml_parse.extract_xml'
      )
    ) {
      this.loader.hideLoader();
    }
    if (
      this.router.url.split('?')[0] == '/home/pos-bills' &&
      request.url.includes('method/upload_file')
    ) {
      this.loader.hideLoader();
    }
    if (window.location.href.includes('home/dashboard')) {
      // this.loader.hideLoader();
    }

    if (window.location.href.includes('/clbs/')) {
      let company = JSON.parse(localStorage.getItem('company'));
      if (!company?.name) {
        window.location.reload();
      }
      if (company?.clbs == 0) {
        this.toastr.info('CLBS module is disabled.');
        this.router.navigate(['']);
      }
    }

    // const baseUrl = this.router.url.split('?')[0];  //this.router.url.split('?')[0].split('/').slice(0, -1).join('/') + '/';

    let route_url = this.cleanUrl(this.router.url.split('?')[0])
    // console.log('token url === ', route_url);
    let headers: { [key: string]: string } = {
      'cache-control': 'no-cache',
    };

    if (route_url) {
      headers['route'] = route_url;
    }

    let temp = request.clone({
      url: request.url
        .replace(/%/, '%25')
        .replace('#', '%23')
        .replace('*', '%2A')
        .replace('-', '%2D'),
      setHeaders: headers,
    });
    // if (this.storage.getRawValue('CUSTOMER')) {
    //   temp = request.clone({
    //     setHeaders: {
    //       authorization: `Bearer ${this.storage.getRawValue('CUSTOMER')}`
    //     }
    //   });
    // }

    return next
      .handle(temp)
      .pipe(
        map((event) => {
          return event;
        }),
        finalize(() => {
          if (this.nonLoadingApis.indexOf('api/api/' + request.url) == -1) {
            this.apiCount--;
            if (this.apiCount <= 0) {
              this.loader.hideLoader();
            }
          }
        }),
        catchError((err) => {
          console.log('errrrrrrrrrrrrrrrrrrrrr', err.error?.exc_type);
          if (err?.error?.exc_type == 'CSRFTokenError' && err.status === 400) {
            this.clearCache();
            this.toastr.error('Session Expired');
          }
          if (err.status === 401) {
            this.clearCache();
            this.toastr.error('Unauthorized');
          }
          if (err.status === 500) {
            this.toastr.error('Internal Error 500');
          }
          if (err.status === 403) {
            // this.toastr.error("Forbidden Error 403")
          }
          if (err.status === 409) {
            this.toastr.error('Already Exists');
          }
          if (err.status === 400 && err?.error?.exc_type != 'CSRFTokenError') {
            this.toastr.error('Bad Request');
          }
          if (err.status === 417) {
            const errMsg = JSON.parse(err.error?._server_messages || '[]')[0];
            this.toastr.error(
              JSON.parse(errMsg)?.message || 'Unexpected error'
            );
          }
          return throwError(err);
        })
      )
      .pipe(takeUntil(this.onCancelPendingRequests()));
  }

  clearCache() {
    localStorage.clear();
    sessionStorage.clear();
    this.cookie.deleteAll();
    let cookie_names = ['sid', 'user_id', 'full_name', 'system_user'];
    cookie_names.forEach((name) => {
      document.cookie = `${name}="guest"; expire=2022-08-05T06:43:18.966Z; path=/;`;
    });

    this.router.navigate(['']);
    return;
  }

  cleanUrl(url: any) {
    const parts = url.split('/');
    return parts.length > 3 ? parts.slice(0, -1).join('/') + '/' : url;
  }
}
